import { useEffect, useState } from "react";
import FlexRow from "../../../../../components/base/FlexRow";
import Icon from "../../../../../components/base/Icon";
import IconButton from "../../../../../components/base/IconButton";
import Job from "../../models/Job";
import { getUser, hasRole, openEditJobClient, useHub, useHasMaskedJobCalls } from "../../../../../core/Global";
import { UserTypes } from "../../../../../core/Enums";
import { API_ROUTES } from "../../../../../core/Constants";

interface IProps {
    job: Job
}
export default function JobDrawerClient(props: IProps) {

    const hub = useHub()
    const user = getUser()
    const [showMore, showMoreSet] = useState<boolean>(false)
    const [proxyLine, proxyLineSet] = useState<string>()
    const [proxyLineRaw, proxyLineRawSet] = useState<string>()
    // Whether there is a proxy number to show at all.
    const maskedAllowed = useHasMaskedJobCalls()

    useEffect(() => {
        if (showMore) $("#drawer-client-more").slideDown()
        else $("#drawer-client-more").slideUp()
    }, [showMore])

    useEffect(() => {
        if (!window.isNullOrEmpty(props.job.phoneContact?.phone)
            || !window.isNullOrEmpty(props.job.company)) showMoreSet(true)
    }, [props.job])

    useEffect(() => {
        hub.Get(API_ROUTES.Jobs + "sendsettings/" + props.job.id, res => {
            proxyLineSet(res.data.proxyLine);
            proxyLineRawSet(res.data.proxyLineRaw);
        })
    }, [])

    return (
        <div>
            <div className="row">
                <div className="col-4 col-md-4">
                    <div>
                        <div className="text-muted fs-8">
                            <Icon icon="user" size={10} className="me-2" type="solid" />
                            Name
                        </div>
                        <div className="ps-5">
                            {props.job.fullName}
                        </div>
                    </div>
                </div>
                <div className="col-8 col-md-5">
                    <div>
                        <div className="text-muted fs-8">
                            <Icon icon="phone-rotary" size={10} className="me-2" type="solid" />
                            Phone
                        </div>
                        {
                            user?.isTech && (props.job.isClosed || props.job.isCanceled) ?
                                <div className="ps-5">
                                    -
                                </div>
                                : user?.isTech && !props.job.techAccepted ?
                                    // Hide the customer's number until the technician accepts the job:
                                    // masked and not dialable.
                                    <div className="ps-5 text-muted" title="Accept the job to reveal the phone number">
                                        <Icon icon="lock" size={11} className="me-2" />
                                        {(props.job.phone?.phoneFriendly ?? "").replace(/\d/g, "•") || "••••"}
                                    </div>
                                :
                                <>
                                    {
                                        user?.isTech && maskedAllowed &&
                                            !props.job.ignoreNotCalledText?.toLowerCase().includes("direct") ?
                                            <div className="ps-5">
                                                <a href={`tel:${proxyLineRaw},${props.job.sentPasscode}`}>
                                                    {proxyLine},{props.job.sentPasscode}
                                                </a>
                                            </div>
                                            :
                                            <div className="ps-5">
                                                {
                                                    user?.userType == UserTypes.Technician ?
                                                        <a href={`tel:${props.job.phoneRaw}${window.isNullOrEmpty(props.job.phone?.extension) ? "" : " , " + props.job.phone?.extension}`}>
                                                            {props.job.phone?.phoneFriendly}{window.isNullOrEmpty(props.job.phone?.extension) ? "" : " , " + props.job.phone?.extension}
                                                        </a>
                                                        :
                                                        <>
                                                            {props.job.phone?.phoneFriendly}{window.isNullOrEmpty(props.job.phone?.extension) ? "" : " , " + props.job.phone?.extension}
                                                        </>
                                                }
                                            </div>
                                    }
                                </>
                        }

                    </div>
                </div>
                {
                    user?.userType != UserTypes.Technician &&
                    <div className="col-md-3">
                        <FlexRow justify="end">
                            {
                                (!props.job.isArchived || hasRole("EditArchivedJobs")) &&
                                <IconButton icon="edit" size={14} type="solid" title="Edit Client"
                                    onClick={e => {
                                        openEditJobClient(props.job)
                                    }} />
                            }

                            <IconButton icon={showMore ? "chevron-up" : "chevron-down"} size={14} type="solid"
                                title={showMore ? "Show less" : "Show more"}
                                onClick={e => showMoreSet(s => !s)} />

                        </FlexRow>
                    </div>
                }

            </div>
            <div id="drawer-client-more" className="mt-3" style={{ display: "none" }}>
                <div className="row">
                    <div className="col-4 col-md-4">
                        <div>
                            <div className="text-muted fs-8">
                                <Icon icon="briefcase" size={10} className="me-2" type="solid" />
                                Company
                            </div>
                            <div className="ps-5">
                                {props.job.company ?? "-"}
                            </div>
                        </div>
                    </div>
                    <div className="col-8 col-md-4">
                        <div>
                            <div className="text-muted fs-8">
                                <Icon icon="phone-rotary" size={10} className="me-2" type="solid" />
                                Secondary Phone
                            </div>
                            {
                                user?.isTech && (props.job.isClosed || props.job.isCanceled) ?
                                    <div className="ps-5">
                                        -
                                    </div>
                                    : user?.isTech && !props.job.techAccepted ?
                                        <div className="ps-5 text-muted" title="Accept the job to reveal the phone number">
                                            <Icon icon="lock" size={11} className="me-2" />
                                            {(props.job.phoneContact?.phoneFriendly ?? "").replace(/\d/g, "•") || "••••"}
                                        </div>
                                    :
                                    <>
                                        {
                                            user?.isTech && maskedAllowed &&
                                                !props.job.ignoreNotCalledText?.toLowerCase().includes("direct") ?
                                                <div className="ps-5">
                                                    <a href={`tel:${proxyLineRaw},${props.job.secondarySentPasscode}`}>
                                                        {proxyLine},{props.job.secondarySentPasscode}
                                                    </a>
                                                </div>
                                                :
                                                <div className="ps-5">
                                                    {
                                                        user?.userType == UserTypes.Technician ?
                                                            <a href={`tel:${props.job.phoneContact?.phone}${window.isNullOrEmpty(props.job.phoneContact?.extension) ? "" : " , " + props.job.phoneContact?.extension}`}>
                                                                {props.job.phoneContact?.phoneFriendly}{window.isNullOrEmpty(props.job.phoneContact?.extension) ? "" : " , " + props.job.phoneContact?.extension}
                                                            </a>
                                                            :
                                                            <>
                                                                {props.job.phoneContact?.phoneFriendly ?? "-"}{window.isNullOrEmpty(props.job.phoneContact?.extension) ? "" : " , " + props.job.phoneContact?.extension}
                                                            </>
                                                    }
                                                </div>
                                        }
                                    </>
                            }

                        </div>
                    </div>
                </div>
                <div className="row mt-3">
                    <div className="col-12">
                        <div>
                            <div className="text-muted fs-8">
                                <Icon icon="envelope" size={10} className="me-2" type="solid" />
                                Email Address
                            </div>
                            <div className="ps-5">
                                {props.job.emailAddress ?? "-"}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}